export const CREDENTIALS_LINK = 'https://apidocs.anrok.com/tutorials/#create-an-api-key';
